<template>
  <div class="d_export">
    <!-- {{ params }}

    {{ summary }} -->

    <h2>
      {{ summary.periode }}
    </h2>

    <a-divider></a-divider>
    <div style="display: flex; justify-content: space-evenly; text-align: left">
      <div style="width: 240px">
        Taux Conseil <strong>%</strong>

        <a-input-number
          style="width: 240px"
          size="large"
          v-model:value="params.taux_conseil"
          :disabled="pdfLoading"
          :min="0.1"
          :max="10.0"
          :step="0.1"
        ></a-input-number>
      </div>
      <div style="width: 240px">
        Taux Assureur <strong>%</strong> <span style="font-size: 8px">(Y compris fond social)</span>
        <a-input-number
          style="width: 240px"
          size="large"
          v-model:value="params.taux_assureur"
          :disabled="pdfLoading"
          :min="0.1"
          :max="10.0"
          :step="0.1"
        ></a-input-number>
      </div>
    </div>
    <a-divider></a-divider>

    <!-- TODO waiting PDF -->

    <a-button
      type="primary"
      @click="init()"
      :loading="pdfLoading"
      size="large"
      shape="round"
      style="z-index: 10"
    >
      Générer le compte de résultat
    </a-button>

    <a-divider></a-divider>

    <a-button
      v-if="download_link"
      :href="download_link"
      type="primary"
      shape="round"
    >
      Télécharger
    </a-button>
  </div>
</template>

<script>
import { message } from "ant-design-vue";

export default {
  data() {
    return {
      pdfLoading: false,
      download_link: null,
    };
  },
  watch:{
    timestamp(){
      this.download_link = null
    }
  },
  props: {
    timestamp: {
      type: Number,
      required: false,
    },
    params: {
      type: Object,
      required: true,
    },
    summary: {
      type: Object,
      required: true,
    },
    json_data: {
      type: Object,
      required: true,
    },
  },
  methods: {
    async init() {
      // arraybuffer
      // this.$axios
      //   .get("http://localhost:8000/doc/download/2695", {
      //     responseType: "blob",
      //   })
      //   .then((r) => {
      //     if (r.status === 200) {
      //       const url = window.URL.createObjectURL(new Blob([response.data]));
      //       const link = document.createElement("a");
      //       link.href = url;
      //       link.setAttribute("download", "image.png");
      //       document.body.appendChild(link);
      //       link.click();
      //     }
      //   });

      // return;
      this.download_link = null;
      this.pdfLoading = true;
      this.params.broker_name = this.summary.broker_name
      this.params.edit_data_date = this.summary.edit_data_date
      this.params.for = this.summary.for
      this.params.stop_data_date = this.summary.stop_data_date
      this.params.year = this.summary.year
      this.params.periode = this.summary.periode


      this.$axios
        .post(
          `/data/generate/graphique/${this.type}/${
            this.num
          }/?${new URLSearchParams(this.params)}`
        )
        .then((r) => {
          if (r.status === 200) {
            this.capture(r.data.uuid);
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally((f) => {
          this.pdfLoading = false;
        });
    },
    async capture(uuid) {
      setTimeout(() => {
        this.pdfLoading = true;
      }, 0);
      this.$axios
        .get(process.env.VUE_APP_NODE_URL + uuid)
        .then((r) => {
          if (r.status === 200) {
            this.download_link = r.data.download_link;
            console.log(r.data);
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally((f) => {
          this.pdfLoading = false;
        });
    },
    _getParams(graph = "pop") {
      //   this.loading = true;
      this.$axios
        .get(
          `/data/company/stat/${this.type}/${
            this.num
          }/params/?${new URLSearchParams({
            graph,
          })}`
        )
        .then((r) => {
          if (r.status === 200) {
            this.params = r.data;
            // this.getClientStat();
          }
        });
    },

  },
  computed: {
    type() {
      return this.$route.params.type;
    },
    num() {
      return this.$route.params.num;
    },
  },
  created() {
    console.log("request data");
  },
};
</script>

<style scoped>
.d_export {
  width: 1100px;
  height: 500px;
  box-shadow: 0 0 3px 0 #ccc;
  border-radius: 10px;
  background-color: white;
  margin: 20px auto 0;
  padding: 20px;
  position: relative;
  text-align: center;
}
</style>